import { AccountResponseT, AccountT } from '../../types';
import { addressTransform } from '../address/address';
import { incomeTransform } from '../income/income';
import { maritalInformationTransform } from '../marital-information/marital-information';

export const deserializeAccount = (response: AccountResponseT): AccountT => {
  return {
    accountId: response.account_id,
    address: addressTransform.deserialize(response.address),
    debitCardLockActive: response.debit_card_lock_active,
    drawLockActive: response.draw_lock_active,
    email: response.login,
    firstName: response.first_name,
    income: incomeTransform.deserialize(response.income),
    lastName: response.last_name,
    lastVerifiedAt: response.last_verified_at,
    loginLockActive: response.login_lock_active,
    maritalInformation: (
      response.marital_information && maritalInformationTransform.deserialize(response.marital_information)
    ),
    passwordExists: response.password_exists,
    phoneNumber: response.phone_number,
    reapplicationLockActive: response.reapplication_lock_active,
  };
};
